import React from 'react';
import { ExpandedInfoILInner } from './ExpandedInfoILInner';
import { HistoryHebrewItem } from 'store/state/selectors/insights/prices';

export const ExpandedInfo: React.FC<{ item: HistoryHebrewItem }> = ({ item }) => {
  return <ExpandedInfoILInner item={item}/>;
};
